// deps
import React from "react";

// internal-deps
import { FlipkartSuperCoins, FlipkartSuperCoinsPaymentGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePaymentActions } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePaymentActions";
import useFlipkartCoins from "@payment-client/hooks/useFlipkartCoins";

export interface FlipkartSuperCoinsGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: FlipkartSuperCoinsPaymentGroup["paymentData"];
}

export function FlipkartSuperCoinsGroupHandler(props: FlipkartSuperCoinsGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const paymentActions = usePaymentActions({ onSelect, onPay });

    const onFlipkartToolTipShow = useFlipkartCoins(true);

    return (
        <FlipkartSuperCoins
            paymentActions={paymentActions}
            paymentData={props.paymentGroup}
            onFlipkartToolTipShow={onFlipkartToolTipShow}
            {...otherProps}
        />
    );
}
